import type * as ProjectPageViewTypes from '../../state/views/projectPage/types';
import {
  EMPTY_PANEL_BANK_CONFIG,
  EMPTY_PANEL_BANK_SECTION_CONFIG_FOR_REPORT,
} from '../../util/panelbankConfigs';
import * as Section from '../../util/section';
import {getLinePlotTemplateValues} from '../WorkspaceTemplate/runLinePlots/useLinePlotSections';
import {getWorkspaceLayoutTemplateValues} from '../WorkspaceTemplate/workspaceLayout/useWorkspaceLayoutSections';
import {type WorkspaceTemplate} from '../WorkspaceTemplate/workspaceTemplatesQueries';

function defaultConfig(): Section.Config {
  return {
    openRunSet: 0,
    runSets: [Section.emptyRunSetSelectAll()],
    panelBankConfig: EMPTY_PANEL_BANK_CONFIG,
    panelBankSectionConfig: EMPTY_PANEL_BANK_SECTION_CONFIG_FOR_REPORT,
    customRunColors: {},
    workspaceSettings: {},
  };
}

function defaultMultiRunViewSpec(): ProjectPageViewTypes.ProjectPageViewSpec {
  return {
    vizExpanded: false,
    libraryExpanded: true,
    section: defaultConfig(),
  };
}

export const createMultiRunDefaultSpec = (
  workspaceTemplate: WorkspaceTemplate | undefined
): ProjectPageViewTypes.ProjectPageViewSpec => {
  const config = defaultConfig();
  return {
    ...defaultMultiRunViewSpec(),
    section: {
      ...config,
      workspaceSettings: {
        linePlot: {
          ...getLinePlotTemplateValues(workspaceTemplate),
        },
        ...getWorkspaceLayoutTemplateValues(workspaceTemplate),
        scatterDefaultByWorkspaceType: true,
      },
    },
  };
};
